/**
 * Method to construct iFrame URL based on provided parameters
 * @param {string} cSource - Campaign Source, required
 * @param {string} cid - Campaign ID, required
 * @param {boolean} draft - Draft mode, optional
 * @param {string} channelSrc - Channel Source, optional
 * @param {string} acid - Alternate Customer ID, optional
 * @returns {string|null} - Constructed iFrame URL or null if any required parameter is missing
 */
export const buildIframeUrl = (cSource, cid, draft, channelSrc, acid) => {
  if ((cSource && cSource.toLowerCase() !== "jebbit") || !cid) {
    console.error("Invalid or missing required parameters: cSource or cid.");
    return null;
  }

  let iFrameUrl = `https://marriott.jebbit.com/${cid}`;
  let queryParamAdded = false;

  if (draft && draft.toLowerCase() === "true") {
    iFrameUrl += "?draft=true";
    queryParamAdded = true;
  }

  if (channelSrc) {
    iFrameUrl += queryParamAdded ? `&L=${channelSrc}` : `?L=${channelSrc}`;
    queryParamAdded = true;
  }

  if (acid) {
    iFrameUrl += queryParamAdded ? `&uid=${acid}` : `?uid=${acid}`;
  }

  return iFrameUrl;
};

